import React, {FC} from 'react';

import {Plural} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {TeamModel} from '../../../../libs/shared/core/src/models/api/teamModel';
import {RoleModel} from '../../../models/api/roleModel';
import {SettingsSearchDropdownItemBaseProps} from './settingsSearchCommonTypes';
import {SettingsSearchDropdownGenericItem} from './settingsSearchDropdownGenericItem';
import {SettingsSearchDropdownTeamAccessory} from './settingsSearchDropdownTeamAccessory';

/*
 * Props.
 */

interface SettingsSearchDropdownRoleItemProps extends SettingsSearchDropdownItemBaseProps {
  team?: TeamModel;
  role: RoleModel;
  teammatesCount: number;
}

/*
 * Component.
 */

export const SettingsSearchDropdownRoleItem: FC<SettingsSearchDropdownRoleItemProps> = (props) => {
  const {role, team, onSelect, teammatesCount} = props;

  return (
    <SettingsSearchDropdownGenericItem
      label={role.name}
      onSelect={onSelect}
      iconName="briefcaseFilledSmall"
      title={
        <>
          {role.name}
          {team && <SettingsSearchDropdownTeamAccessory team={team} />}
        </>
      }
      subtitle={
        <Plural
          value={teammatesCount}
          id="settingssearchrole-teammatescount"
          one="One teammate"
          _0="No teammates"
          other="# teammates"
        />
      }
    />
  );
};
